'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _neptune = require('./neptune');

var _neptune2 = _interopRequireDefault(_neptune);

var _n2 = require('./_n');

var _n3 = _interopRequireDefault(_n2);

var _unfetch = require('../../node_modules/unfetch');

var _unfetch2 = _interopRequireDefault(_unfetch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_neptune2.default.periscope = {
  cache: {}
};

_neptune2.default.periscope.init = function (p) {

  p = p || document;

  _n3.default.qsa('[neptune-periscope]', p).forEach(function (el) {

    _neptune2.default.debug.info('periscope:init', { el: el });

    if (el.getAttribute('neptune-periscope').indexOf('{') < 0) return _neptune2.default.periscope.view(el, el.getAttribute('neptune-periscope'));

    var periscope = USON.parse(el.getAttribute('neptune-periscope'));

    if (!!periscope) return _neptune2.default.periscope.load(el, periscope[0]);
  });
};

_neptune2.default.periscope.preload = function (url) {
  if (!!_neptune2.default.periscope.cache[url]) return false;
  (0, _unfetch2.default)(url).then(function (r) {
    return r.text();
  }).then(function (html) {
    _neptune2.default.periscope.cache[url] = html;
  });
};

_neptune2.default.periscope.load = function (el, view) {

  view.position = view.position || 'contents';

  if (view.position == 'contents') el.innerHTML = '';

  (0, _unfetch2.default)(view.url, view).then(function (r) {
    return r.text();
  }).then(function (html) {

    if (view.position == 'contents') {
      el.innerHTML = html;
    }
    if (view.position == 'prepend') {
      el.innerHTML = html + el.innerHTML;
    }
    if (view.position == 'append') {
      el.innerHTML = el.innerHTML + html;
    }

    _n3.default.trigger(document, 'periscope:loaded', false, true, { el: el, view: view });
    _n3.default.qsa('script', el).forEach(function (script) {
      if (script.getAttribute('type') && script.getAttribute('type').includes('template')) return false;
      if (script.getAttribute('type') && script.getAttribute('type').includes('json')) return false;
      if (script.getAttribute('data-product-json')) return false;
      if (!!script.innerText && script.innerText.indexOf('(')) eval(script.innerText);
    });
  });
};

_neptune2.default.periscope.loaded = function (el, callback, clearPermanent, url) {

  if (!clearPermanent) {
    _n3.default.qsa('[neptune-permanent]', el).forEach(function (p) {
      try {
        p.parentNode.replaceChild(_neptune2.default.preserved[p.getAttribute('neptune-permanent')], p);
      } catch (err) {}
    });
  }

  _n3.default.qsa('script', el).forEach(function (script) {
    if (script.getAttribute('data-product-json')) return false;
    if (script.hasAttribute('data-json')) return false;
    if (script.hasAttribute('neptune-permanent')) return false;
    if (script.getAttribute('type') && script.getAttribute('type').includes('template')) return false;
    if (script.getAttribute('type') && script.getAttribute('type').includes('json')) return false;
    if (!!script.innerText && script.innerText.indexOf('(')) {
      try {
        eval(script.innerText);
      } catch (err) {
        //nada
      }
    }
  });

  el.classList.remove("periscope-loading");
  _n3.default.trigger(document, "periscope:viewed", false, true, {
    el: el,
    url: url,
    meta: meta
  });

  if (!!callback) setTimeout(callback, 10);
};

_neptune2.default.periscope.view = function (el, url, meta, callback, clearPermanent) {

  _n3.default.trigger(document, 'periscope:view', false, true, { el: el, url: url, meta: meta });
  _neptune2.default.debug.info('periscope:view', { el: el, url: url });

  el.classList.add('periscope-loading');

  // el.innerHTML = ''
  if (!clearPermanent) {
    _neptune2.default.preserved = {};
    _n3.default.qsa('[neptune-permanent]', el).forEach(function (p) {
      p.setAttribute('permanent', p.getAttribute('neptune-permanent'));
      _neptune2.default.preserved[p.getAttribute('neptune-permanent')] = p;
    });
  }

  if (!!_neptune2.default.periscope.cache[url]) {
    el.innerHTML = _neptune2.default.periscope.cache[url];
    _neptune2.default.periscope.loaded(el, callback, clearPermanent);
  } else {

    (0, _unfetch2.default)(url, {
      method: 'GET',
      credentials: 'include'
    }).then(function (r) {
      return r.text();
    }).then(function (html) {

      _n3.default.trigger(document, 'periscope:preview', false, true, { el: el, url: url, meta: meta });

      el.innerHTML = html;

      _neptune2.default.periscope.loaded(el, callback, clearPermanent, url);
    });
  }
};

window.Neptune = _neptune2.default;

exports.default = _neptune2.default.periscope;